// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-info-container {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;
}



.key-value-pair {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.account-button-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
}

.account-button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.account-button-container > * {
    flex: 0 0 auto;
}

.account-button-container .button-primary {
    height: 3rem;
}

.account-button-container .button-secondary {
    height: 2rem;
}

`, "",{"version":3,"sources":["webpack://./src/Account.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".account-info-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    width: 100%;\n}\n\n\n\n.key-value-pair {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.account-button-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.account-button-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.account-button-container > * {\n    flex: 0 0 auto;\n}\n\n.account-button-container .button-primary {\n    height: 3rem;\n}\n\n.account-button-container .button-secondary {\n    height: 2rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
